import { useDispatch, useSelector } from 'react-redux';
import { compose } from 'recompose';

import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import withAcls from '~/common/hoc/withAcls';
import withHooks from '~/common/hoc/withHooks';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';

const enhancer = compose(
  withAcls,
  withHooks(props => {
    const { GOVERNANCE_REDIRECT_CONSUMPTION_TO_TOGAI } = featureFlagConstants;
    const { application, realms, license } = useSelector(state => state);
    const { treatments } = useFeatureFlag([
      GOVERNANCE_REDIRECT_CONSUMPTION_TO_TOGAI
    ]);

    const dispatch = useDispatch();
    const state = {
      realm: application.realm.realm,
      togaiToken: application.togaiToken,
      realmData: realms.getRealm,
      license: license.license,
      showTogaiRedirectButton:
        treatments[GOVERNANCE_REDIRECT_CONSUMPTION_TO_TOGAI].treatment === 'on',
      hasCustomerIdentityProvider: application.hasCustomerIdentityProvider
    };
    const actions = {
      onPressBack: isTargetBlank => {
        const path = `/${state.realm}/operation/build/pipelines`;

        if (isTargetBlank) return window.open(path, '_blank');

        return dispatch.router.navigate({ to: path });
      }
    };

    return {
      ...props,
      ...state,
      ...actions
    };
  })
);

export default enhancer;
